import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ICellRendererParams } from 'ag-grid-community'
import { DefaultCellContentWrapper } from './DefaultCellRenderer'
import { gridRowIdInEditSelector } from 'selectors/selectionSelectors'

export interface GridAxeTradeConditionButtonsProps<T = unknown> {
  data: T
  rowInEdit: boolean
  onUpdate: (id: string, data: T, field: string, newValue: any) => unknown
}

interface AxeTradeConditionRendererProps extends ICellRendererParams {
  gridRowIdInEdit: string | null
}

export function createAxeTradeConditionRenderer<T>(
  GridAxeTradeConditionButtons: React.ComponentType<GridAxeTradeConditionButtonsProps<T>>
) {
  const mapStateToProps = createStructuredSelector({
    gridRowIdInEdit: gridRowIdInEditSelector
  })

  const mapDispatchToProps = {}

  class AxeTradeConditionRenderer extends React.Component<AxeTradeConditionRendererProps> {
    render() {
      const { node, gridRowIdInEdit } = this.props
      const data: T | null = node.group ? null : node.data

      return data ? (
        <DefaultCellContentWrapper>
          <GridAxeTradeConditionButtons data={data} rowInEdit={gridRowIdInEdit === node.id} onUpdate={this.handleUpdate} />
        </DefaultCellContentWrapper>
      ) : null
    }

    private handleUpdate = (id: string, data: T, field: string, value: any) => {
      this.props.context.updateCellValue(id, data, field, value)
    }

    refresh = () => {
      this.forceUpdate()
      return true
    }
  }

  return connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AxeTradeConditionRenderer)
}
